import { Dimensions, DimensionsConfig } from '../domain/content/entities/valueobjects/Dimensions';
import { Fields } from '../domain/content/entities/valueobjects/Fields';
import { GroupedOrStackedTypes, LineChartTypes, MapTypes, NoDimensionRequirements, TwoDimensionalChartTypes, MapWithDataTypes, EChartTypes } from './constants';
import { getSubType } from '../content/echarts/utilities';
import { EChartType } from '../domain/content/entities/valueobjects/TypeSpecific';

export const getDimensionsConfig = (type: string): DimensionsConfig => {
  if (NoDimensionRequirements.includes(type)) {
    return [];
  }

  if (MapTypes.includes(type)) {
    switch (type) {
      case 'bubblemap':
      case 'extrudemap':
      case 'choropleth':
        return [
          {
            dimName: 'iso',
            dimLabel: 'editor.visual.type.region',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['isoLabelField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'value',
            dimLabel: 'editor.visual.type.value',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];

      case 'multimap':
        return [
          {
            dimName: 'geo',
            dimLabel: 'editor.visual.type.geo',
            fieldName: undefined,
            usedForUniqueness: false,
            requirements: {
              fieldTypes: ['geoField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'label',
            dimLabel: 'editor.visual.type.label',
            fieldName: undefined,
            usedForUniqueness: false,
            requirements: {
              fieldTypes: ['miscField'],
            },
            possibleFields: [],
          },
          // {
          //   dimName: 'iso',
          //   dimLabel: 'editor.visual.type.region',
          //   fieldName: undefined,
          //   usedForUniqueness: true,
          //   requirements: {
          //     fieldTypes: ['isoLabelField'],
          //   },
          //   possibleFields: [],
          // },
          // {
          //   dimName: 'value',
          //   dimLabel: 'editor.visual.type.value',
          //   usedForUniqueness: false,
          //   fieldName: undefined,
          //   requirements: {
          //     fieldTypes: ['valueField'],
          //   },
          //   possibleFields: [],
          // },
        ];

      default:
        break;
    }
  }

  if (TwoDimensionalChartTypes.includes(type)) {
    switch (type) {
      case 'barchart':
        return [
          {
            dimName: 'xAxis',
            dimLabel: 'editor.visual.type.xAxis',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'yAxis',
            dimLabel: 'editor.visual.type.yAxis',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];
      case 'horizontalbarchart':
        return [
          {
            dimName: 'xAxis',
            dimLabel: 'editor.visual.type.xAxis',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'yAxis',
            dimLabel: 'editor.visual.type.yAxis',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];
      default:
        return [
          {
            dimName: 'xAxis',
            dimLabel: 'editor.visual.type.xAxis',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'yAxis',
            dimLabel: 'editor.visual.type.yAxis',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];
    }
  }

  if (GroupedOrStackedTypes.includes(type)) {
    switch (type) {
      case 'stackedbarchart':
        return [
          {
            dimName: 'groupAxis',
            dimLabel: 'editor.visual.type.xAxis',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'xAxis',
            dimLabel: 'editor.visual.type.stacks',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'yAxis',
            dimLabel: 'editor.visual.type.yAxis',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];
      case 'bar-stacked-horizontal':
        return [
          {
            dimName: 'groupAxis',
            dimLabel: 'editor.visual.type.xAxis',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'xAxis',
            dimLabel: 'editor.visual.type.stacks',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'yAxis',
            dimLabel: 'editor.visual.type.yAxis',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];
      case 'groupedbarchart':
        return [
          {
            dimName: 'groupAxis',
            dimLabel: 'editor.visual.type.xAxis',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'xAxis',
            dimLabel: 'editor.visual.type.groups',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'yAxis',
            dimLabel: 'editor.visual.type.yAxis',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];
      case 'bar-grouped-horizontal':
      case 'x-plot':
        return [
          {
            dimName: 'groupAxis',
            dimLabel: 'editor.visual.type.xAxis',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'xAxis',
            dimLabel: 'editor.visual.type.groups',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'yAxis',
            dimLabel: 'editor.visual.type.yAxis',
            usedForUniqueness: false,
            fieldName: undefined,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];

      default:
        console.log('[getDimensionsConfig] Error dimension type not found', type);
        return [];
    }
  }

  if (LineChartTypes.includes(type)) {
    return [
      {
        dimName: 'xAxis',
        dimLabel: 'editor.visual.type.xAxis',
        fieldName: undefined,
        usedForUniqueness: true,
        requirements: {
          fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
        },
        possibleFields: [],
      },
      {
        dimName: 'labelAxis',
        dimLabel: 'editor.visual.type.series',
        fieldName: undefined,
        usedForUniqueness: true,
        requirements: {
          fieldTypes: ['miscField', 'isoLabelField', 'timeField'],
        },
        possibleFields: [],
      },

      {
        dimName: 'yAxis',
        dimLabel: 'editor.visual.type.yAxis',
        usedForUniqueness: false,
        fieldName: undefined,
        requirements: {
          fieldTypes: ['valueField'],
        },
        possibleFields: [],
      },
    ];
  }

  if (EChartTypes.includes(type)) {
    switch (type) {
      case EChartType.Sankey:
        return [
          {
            dimName: 'source',
            dimLabel: 'Source',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'target',
            dimLabel: 'Target',
            fieldName: undefined,
            usedForUniqueness: true,
            requirements: {
              fieldTypes: ['miscField'],
            },
            possibleFields: [],
          },
          {
            dimName: 'value',
            dimLabel: 'Value',
            fieldName: undefined,
            usedForUniqueness: false,
            requirements: {
              fieldTypes: ['valueField'],
            },
            possibleFields: [],
          },
        ];

      default:
        return [];
    }
  }

  console.log('No requirements for type:', type);
  return [];
};

export const getValueFieldName = (dimensions: Dimensions) => {
  if (!dimensions) return null;

  for (const dimension of dimensions) {
    if (dimension.requirements.fieldTypes.includes('valueField')) {
      return dimension.fieldName;
    }
  }

  return null;
};

// FlowChartTypes
export const getSourceTargetFieldNames = (dimensions: Dimensions) => {
  if (!dimensions) return [null, null];
  const source = dimensions.find((obj) => obj.dimName === 'source')?.fieldName;
  const target = dimensions.find((obj) => obj.dimName === 'target')?.fieldName;
  return [source, target];
};

export const getSourceFieldName = (dimensions: Dimensions) => {
  if (!dimensions) return null;

  for (const dimension of dimensions) {
    if (dimension.requirements.fieldTypes.includes('valueField')) {
      return dimension.fieldName;
    }
  }
  return null;
};

/**
 * used by Chart Manager doesnt deal with choros!
 */
export const getOldFields = (type: string, dimensions: Dimensions) => {
  if (!type || !dimensions) return undefined;

  if (TwoDimensionalChartTypes.includes(type)) {
    return {
      labelField: dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName,
      valueField: dimensions.find((obj) => obj.dimName === 'yAxis')?.fieldName,
      aggregationField: undefined,
      timeField: undefined,
    };
  }

  if (GroupedOrStackedTypes.includes(type)) {
    return {
      labelField: dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName,
      valueField: dimensions.find((obj) => obj.dimName === 'yAxis')?.fieldName,
      aggregationField: dimensions.find((obj) => obj.dimName === 'groupAxis')?.fieldName,
      timeField: undefined,
    };
  }

  if (LineChartTypes.includes(type)) {
    return {
      timeField: dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName,
      valueField: dimensions.find((obj) => obj.dimName === 'yAxis')?.fieldName,
      labelField: dimensions.find((obj) => obj.dimName === 'labelAxis')?.fieldName,
      aggregationField: dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName,
    };
  }

  if (!type || !dimensions) return undefined;
};

/**
 * returns the first timefield from fields object
 * this functon is bad since we can only have one timefield
 * this is cause of backwards compatibility
 * @param fields
 * @returns
 */
export const getTimeFieldName = (fields: Fields) => {
  if (!fields) return null;
  for (const fieldName of Object.keys(fields)) {
    const curField = fields[fieldName];
    if (curField.dataType === 'date') {
      return curField.fieldName;
    }
  }
  return null;
};

/**
 * returns the first geoField from fields object
 * @param fields
 * @returns
 */
export const getGeometryField = (fields: Fields) => {
  if (!fields) return null;
  for (const fieldName of Object.keys(fields)) {
    const curField = fields[fieldName];
    if (curField.fieldType === 'geoField') {
      //console.log("[getIsoFieldName] found isofield: ",curField.fieldName);
      return curField;
    }
  }
  return null;
};

/**
 * returns the of name of the first isoField from fields object
 * this functon is bad since we can only have one isoField
 * this is cause of backwards compatibility
 * @param fields
 * @returns
 */
export const getIsoFieldName = (fields: Fields) => {
  if (!fields) return null;
  for (const fieldName of Object.keys(fields)) {
    const curField = fields[fieldName];
    if (curField.isoLabelField && curField.fieldType === 'isoField') {
      //console.log("[getIsoFieldName] found isofield: ",curField.fieldName);
      return curField.fieldName;
    }
  }
  return null;
};

/**
 * returns the first isoField from fields object
 * this functon is bad since we can only have one isoField
 * this is cause of backwards compatibility
 * @param fields
 * @returns
 */
export const getIsoField = (fields: Fields) => {
  if (!fields) return null;
  for (const fieldName of Object.keys(fields)) {
    const curField = fields[fieldName];
    if (curField.isoLabelField && curField.fieldType === 'isoField') {
      //console.log("[getIsoFieldName] found isofield: ",curField.fieldName);
      return curField;
    }
  }
  return null;
};

export const getFieldByName = (fields: Fields, fieldName: string) => {
  if (!fieldName || !fields) return undefined;
  return fields ? fields[fieldName] : undefined;
};

// CORRECT
export const getRightLegendFieldName = (type: string, dimensions: Dimensions) => {
  if (!type || !dimensions) return null;

  if (TwoDimensionalChartTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName;
  }

  if (LineChartTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'labelAxis')?.fieldName;
  }

  if (GroupedOrStackedTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName;
  }

  if (MapWithDataTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'iso')?.fieldName;
  }

  return null;
};

// CORRECT
export const getRightLabelFieldName = (type: string, dimensions: Dimensions) => {
  if (TwoDimensionalChartTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName;
  }

  if (GroupedOrStackedTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'groupAxis')?.fieldName;
  }

  if (LineChartTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName;
  }

  if (MapWithDataTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'iso')?.fieldName;
  }

  if (MapWithDataTypes.includes(type)) {
    return dimensions.find((obj) => obj.dimName === 'iso')?.fieldName;
  }

  return null;
};

/**
 * TODO this function is inheritely FALSE
 * mostly used in smart functions and smart filters
 * but a lot of old visuals run through this function
 */
export const getLabelFieldName = (type: string, dimensions: Dimensions) => {
  if (dimensions && dimensions.length > 0) {
    if (TwoDimensionalChartTypes.includes(type)) {
      return dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName;
    }

    if (GroupedOrStackedTypes.includes(type)) {
      return dimensions.find((obj) => obj.dimName === 'xAxis')?.fieldName;
    }

    if (LineChartTypes.includes(type)) {
      return dimensions.find((obj) => obj.dimName === 'labelAxis')?.fieldName;
    }

    if (MapWithDataTypes.includes(type)) {
      return dimensions.find((obj) => obj.dimName === 'iso')?.fieldName;
    }
  }

  return null;
};
